import { PropsWithChildren } from 'react';

import { css, cx } from '@emotion/css';
import Card from 'antd/lib/card/Card';
import { BorderRadius, ColorConstant, ScreenBreakpoint, Spacing } from 'src/styles';

const containerStyle = css`
  width: 100%;
  background: ${ColorConstant.GRAY1};
  box-shadow: 0px 4px 16px rgba(2, 85, 163, 0.15);
  border: 1px solid #edf2f7;
  ${BorderRadius.xs}

  .ant-card-body {
    ${Spacing.p0}
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    border-radius: 0;
  }
`;

interface MCardProps {
  className?: string;
}

export const MCard = ({ children, className }: PropsWithChildren<MCardProps>) => {
  return <Card className={cx(containerStyle, className)}>{children}</Card>;
};
